/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  CustomHostname,
  OrganizationPointer,
  SitePointer,
} from "./data-contracts";

/**
 * No description
 * @tags custom-hostnames
 * @name GetCustomHostname
 * @summary Get a custom hostname
 * @request GET:/custom-hostnames/{hostname}
 * @secure
 */

// @ts-ignore
export const getCustomHostname: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The custom hostname, for example "docs.gitbook.com" */
    hostname: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: CustomHostname;
  ResponseStatusCode: 200;
} = {
  route: "/custom-hostnames/{hostname}",
  method: "get",
  streaming: false,
  tags: ["custom-hostnames"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Any previously set custom hostname will continue pointing to the target but marked as available for use with another target.
 * @tags custom-hostnames, internal
 * @name SetupCustomHostname
 * @summary Setup a custom hostname
 * @request POST:/custom-hostnames/{hostname}
 * @secure
 */

// @ts-ignore
export const setupCustomHostname: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The custom hostname, for example "docs.gitbook.com" */
    hostname: string;
  };
  RequestQuery: {};
  RequestBody: {
    target: OrganizationPointer | SitePointer;
  };
  RequestHeaders: {};
  ResponseBody: CustomHostname;
  ResponseStatusCode: 201 | 400 | 409;
} = {
  route: "/custom-hostnames/{hostname}",
  method: "post",
  streaming: false,
  tags: ["custom-hostnames", "internal"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Revalidate DNS records and status.
 * @tags custom-hostnames
 * @name DnsRevalidateCustomHostname
 * @summary Revalidate a custom hostname DNS
 * @request PATCH:/custom-hostnames/{hostname}
 * @secure
 */

// @ts-ignore
export const dnsRevalidateCustomHostname: {
  route: string;
  method: "patch";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The custom hostname, for example "docs.gitbook.com" */
    hostname: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 400 | 409;
} = {
  route: "/custom-hostnames/{hostname}",
  method: "patch",
  streaming: false,
  tags: ["custom-hostnames"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description The custom hostname will continue to point to the content or organization unless it is used for another one.
 * @tags custom-hostnames
 * @name RemoveCustomHostname
 * @summary Remove a custom hostname
 * @request DELETE:/custom-hostnames/{hostname}
 * @secure
 */

// @ts-ignore
export const removeCustomHostname: {
  route: string;
  method: "delete";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The custom hostname, for example "docs.gitbook.com" */
    hostname: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route: "/custom-hostnames/{hostname}",
  method: "delete",
  streaming: false,
  tags: ["custom-hostnames"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Test if a custom hostname can be used for a site or organization.
 * @tags custom-hostnames, internal
 * @name TestCustomHostname
 * @summary Test a custom hostname
 * @request POST:/custom-hostnames/{hostname}/test
 * @secure
 */

// @ts-ignore
export const testCustomHostname: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The custom hostname, for example "docs.gitbook.com" */
    hostname: string;
  };
  RequestQuery: {};
  RequestBody: {
    target: OrganizationPointer | SitePointer;
  };
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 400 | 409;
} = {
  route: "/custom-hostnames/{hostname}/test",
  method: "post",
  streaming: false,
  tags: ["custom-hostnames", "internal"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};
